import React from "react";
import Typography from "@material-ui/core/Typography";
import Container from "@material-ui/core/Container";
import { makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles((theme) => ({
  container: {
    minHeight: "100vh",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    background: "linear-gradient(135deg, #667eea 0%, #764ba2 100%)",
    color: "white",
  },
  paper: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    padding: theme.spacing(6),
    background: "rgba(255, 255, 255, 0.1)",
    borderRadius: theme.spacing(2),
    backdropFilter: "blur(10px)",
    border: "1px solid rgba(255, 255, 255, 0.2)",
    textAlign: "center",
  },
  logo: {
    maxWidth: 200,
    marginBottom: theme.spacing(4),
  },
  title: {
    fontSize: "2.5rem",
    fontWeight: "bold",
    marginBottom: theme.spacing(2),
    color: "white",
  },
  subtitle: {
    fontSize: "1.2rem",
    marginBottom: theme.spacing(3),
    opacity: 0.9,
  },
  message: {
    fontSize: "1rem",
    lineHeight: 1.6,
    maxWidth: 600,
    opacity: 0.8,
  },
  emailLink: {
    color: "white",
    textDecoration: "underline",
    "&:hover": {
      opacity: 0.8,
    },
  },
}));

export default function Farewell() {
  const classes = useStyles();

  return (
    <div className={classes.container}>
      <Container component="main" maxWidth="md">
        <div className={classes.paper}>
          <img
            src={require("../assets/img/Phonic_Logo_4x.png")}
            className={classes.logo}
            alt="Phonic logo"
          />

          <Typography variant="h1" className={classes.title}>
            Thank You
          </Typography>

          <Typography variant="h2" className={classes.subtitle}>
            Phonic is no longer accepting new users
          </Typography>

          <Typography variant="body1" className={classes.message}>
            We want to thank all our users who have been part of the Phonic journey.
            After careful consideration, we have decided to discontinue our public service.
            We're grateful for your support and the insights you've helped us gather over the years.
            <br /><br />
            If you're an existing user, please contact our support team at{" "}
            <a href="mailto:surveyadmin@infillion.com" className={classes.emailLink}>
              surveyadmin@infillion.com
            </a>{" "}
            for assistance with your data.
          </Typography>
        </div>
      </Container>
    </div>
  );
}